import { useT } from '../../../i18n';
import { KHONG_CO } from '../../../lib/dinh-dang';
import { dinhDangHeSo } from '../../goi-nap-token/nghiep-vu/fox';

/** Cột số hẹp của bảng hệ số: bỏ bớt lề mặc định của antd để ba cột liền nhau vẫn vừa màn. */
export const O_SO_HEP = { className: '!px-2' };
/** Cột đầu của một nhóm: thêm đường kẻ để mắt tách được các nhóm khi nhiều nhóm liền nhau. */
export const O_SO_DAU_NHOM = { className: '!px-2 border-l border-default' };

/** Một hệ số trong ô bảng: chỉ con số, căn phải do cột lo; tiêu đề nhóm đã nói đây là hệ số. */
export function SoHeSo({ giaTri }: { giaTri: number | null | undefined }) {
  const { locale } = useT();
  return (
    <span className="whitespace-nowrap tabular-nums">{giaTri == null ? KHONG_CO : dinhDangHeSo(giaTri, locale)}</span>
  );
}

/**
 * Hệ số đọc cache trong ô bảng. Trống nghĩa là bằng hệ số đầu vào (ADR-0123 mục 2): hiện chính số hiệu lực, tông nhạt,
 * để so được giữa các model; lời giải thích ở `title` và cho trình đọc màn hình.
 */
export function SoHeSoCache({ cache, dauVao }: { cache: number | null | undefined; dauVao: number | undefined }) {
  const { t, locale } = useT();
  if (cache != null) return <SoHeSo giaTri={cache} />;
  if (dauVao === undefined) return <SoHeSo giaTri={undefined} />;
  return (
    <span className="whitespace-nowrap tabular-nums text-content-muted" title={t('banToken.heSo.bangHeSoVao')}>
      {dinhDangHeSo(dauVao, locale)}
      <span className="sr-only"> ({t('banToken.heSo.bangHeSoVao')})</span>
    </span>
  );
}
